import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Suspense } from "react";
import { AppLayout } from "./components";
import { BreadcrumbProvider } from "@shared/contexts";
import { WebSocketCallbacks } from '@shared/components';

import {
  publicRoutes,
  mainRoutes,
  communicationRoutes,
  reportsRoutes,
  observatoryRoutes,
  redirectRoutes,
} from "./routes";

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
  </div>
);


export const RootLayout = () => {
  return (
    <BreadcrumbProvider>
      <WebSocketCallbacks>
        <Router>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Rutas públicas */}
              {publicRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              
              {/* Rutas protegidas dentro del AppLayout */}
              <Route element={<AppLayout />}>
                {/* Rutas principales */}
                {mainRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
                
                {/* Rutas de comunicación */}
                {communicationRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
                
                {/* Rutas de reportes */}
                {reportsRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
                
                {/* Rutas del observatorio */}
                {observatoryRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
              </Route>
              
              {/* Rutas de redirección */}
              {redirectRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>
          </Suspense>
        </Router>
      </WebSocketCallbacks>
    </BreadcrumbProvider>
  );
};
